import Link from 'next/link'
import { FOOTER_UTILITY_LINKS } from '../footer-data'
import s from './footer-utility-row.module.scss'

export const FooterUtilityRow = () => {
  return (
    <nav className={s.container} aria-label="Legal">
      <ul className={s.list}>
        {FOOTER_UTILITY_LINKS.map((link) => (
          <li key={link.href} className={s.item}>
            <Link href={link.href} className={s.link}>
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
